import { createTheme } from '@mui/material/styles';

/**
 * Matches the original comment-cards app so the two tools read as siblings.
 * #b74f2a gives 5.04:1 against white — AA for normal text, and safe for white
 * text on a filled button.
 */
export const theme = createTheme({
  palette: {
    primary: { light: '#e97f5a', main: '#b74f2a', dark: '#8f3a1a', contrastText: '#ffffff' },
    text: { primary: '#1a1a1a', secondary: '#4a4a4a' },
    background: { default: '#f5f5f5' },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    // Never drop below 12px, at any breakpoint.
    fontSize: 16,
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    caption: { fontSize: '0.8125rem' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          minHeight: 44,
          padding: '10px 24px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        // Icon-only controls still need a 44px target.
        root: { minWidth: 44, minHeight: 44 },
      },
    },
    MuiPaper: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiChip: { styleOverrides: { label: { fontSize: '0.8125rem' } } },
  },
});
